import React from 'react'

export default function Footer() {
    return (
        <div className="footer m-auto text-center py-3 mt-4">
            Footer
        </div>
    )
}
